import { useTranslation } from 'react-i18next'
import DocumentForm from './document-form.component'

interface Props {
  onToggle: () => void
}

const SendDocumentTab = ({ onToggle }: Props) => {
  const { t } = useTranslation()
  return (
    <>
      <p className="c-text-base">{t('components.documents.signature-request-information')}</p>
      <DocumentForm onCancel={onToggle} />
    </>
  )
}

export default SendDocumentTab
